module.exports = __webpack_public_path__ + "assets/images/home_r.42c1f0df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/home_r.png
// module id = 736
// module chunks = 1